import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImage32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconImage32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 8H7a2 2 0 0 0-2 2v7.277l5.504-3.145.53-.303.51.333 9.52 6.187L27 17.383V10a2 2 0 0 0-2-2m4 9.978V10a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4zm-2 1.64-5.553 2.776-.512.257-.48-.313-9.489-6.167L5 19.58V22a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2zM21.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImage32);
